import { render, staticRenderFns } from "./FoodMajorKindSearch.vue?vue&type=template&id=2cf8aab9&"
import script from "./FoodMajorKindSearch.vue?vue&type=script&lang=js&"
export * from "./FoodMajorKindSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports